import React, { Component } from 'react';
import {Button} from '@betareader/design-system';
import { withTranslation } from 'react-i18next';

export class YoBGetter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      yob: props.initialValue || null
    };
  }

  getYoBOptions = () => {
    const yobOptions = [];
    const currentYear = new Date().getFullYear();
    for (let i = 1920; i <= currentYear; i += 1) {
      yobOptions.push({
        key: i.toString(),
        value: i,
        text: i.toString()
      });
    }
    return yobOptions;
  }

  handleYoBChange = event => {
    const { wizardMode } = this.props;
    this.setState({ yob: event.target.value ? Number(event.target.value) : null }, () => {
      if (wizardMode && this.state.yob !== null) {
        this.submit();
      }
    });
  }

  submit = () => {
    const { yob } = this.state;
    if (this.props.onUpdate) {
      this.props.onUpdate({ yob });
    }
  }

  // render
  render() {
    const { t, updating, wizardMode } = this.props;
    const { yob } = this.state;
    return (
      <div>
        <h2>{t('WhenWereYouBorn')}</h2>
        <p>{t('OnYourProfile')}</p>
        <label className='br-field'>
          <span className='br-field__label'>{t('YoB')}</span>
          <select className='br-field__input' value={yob ?? ''}
            onChange={this.handleYoBChange}>
            <option value=''>{t('YoB')}</option>
            {this.getYoBOptions().map(option => (
              <option key={option.key} value={option.value}>{option.text}</option>
            ))}
          </select>
        </label>
        <Button style={{marginTop: '1em'}} onClick={this.submit}
          disabled={updating} aria-busy={updating}>
          {wizardMode ? (yob === null ? t('Skip') : t('Next')) : t('Save')}
        </Button>
      </div>
    );
  }
}

export default withTranslation()(YoBGetter);
